var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShippingTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    rx: 62,
    fill: "#E5E5E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 52H74.5V42H34.5V74.5H39.5C39.5 78.65 42.85 82 47 82C51.15 82 54.5 78.65 54.5 74.5H69.5C69.5 78.65 72.85 82 77 82C81.15 82 84.5 78.65 84.5 74.5H89.5V62L82 52ZM47 77C45.625 77 44.5 75.875 44.5 74.5C44.5 73.125 45.625 72 47 72C48.375 72 49.5 73.125 49.5 74.5C49.5 75.875 48.375 77 47 77ZM80.75 55.75L85.65 62H74.5V55.75H80.75ZM77 77C75.625 77 74.5 75.875 74.5 74.5C74.5 73.125 75.625 72 77 72C78.375 72 79.5 73.125 79.5 74.5C79.5 75.875 78.375 77 77 77Z",
    fill: "#959BA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingTruck);
export default __webpack_public_path__ + "static/media/shipping_truck.f5de08130c4975e05289165780d4995c.svg";
export { ForwardRef as ReactComponent };